import React from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRight } from 'lucide-react';
import { projects } from '../data/projects';
import { Badge } from './ui/Badge';
export function ProjectShowcase() {
  return <section className="py-20 bg-[#0a0a0a]" data-id="element-130">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-131">
        <div className="flex flex-col md:flex-row justify-between items-end mb-12" data-id="element-132">
          <div data-id="element-133">
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-134">
              Featured Work
            </h2>
            <p className="text-gray-400 max-w-xl" data-id="element-135">
              A selection of our recent projects across web, mobile, and digital
              platforms.
            </p>
          </div>
          <button className="hidden md:flex items-center text-[#0ea5e9] hover:text-white transition-colors mt-4 md:mt-0" data-id="element-136">
            View All Projects <ArrowUpRight className="ml-2 w-5 h-5" data-id="element-137" />
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-138">
          {projects.map((project, index) => <motion.div key={project.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="group cursor-pointer" data-id="element-139">
              <div className="relative overflow-hidden rounded-xl aspect-[4/3] mb-4" data-id="element-140">
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/0 transition-colors z-10" data-id="element-141" />
                <img src={project.image} alt={project.title} className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-500" data-id="element-142" />
                <div className="absolute top-4 left-4 z-20" data-id="element-143">
                  <Badge variant="secondary" className="bg-black/50 backdrop-blur-md border-transparent text-white" data-id="element-144">
                    {project.category}
                  </Badge>
                </div>
              </div>

              <h3 className="text-xl font-bold text-white mb-2 group-hover:text-[#0ea5e9] transition-colors" data-id="element-145">
                {project.title}
              </h3>
              <p className="text-gray-400 text-sm mb-3 line-clamp-2" data-id="element-146">
                {project.description}
              </p>
              <div className="flex flex-wrap gap-2" data-id="element-147">
                {project.tags.map(tag => <span key={tag} className="text-xs text-gray-500 bg-[#1a1a1a] px-2 py-1 rounded" data-id="element-148">
                    {tag}
                  </span>)}
              </div>
            </motion.div>)}
        </div>

        <div className="mt-12 text-center md:hidden" data-id="element-149">
          <button className="inline-flex items-center text-[#0ea5e9] font-medium" data-id="element-150">
            View All Projects <ArrowUpRight className="ml-2 w-5 h-5" data-id="element-151" />
          </button>
        </div>
      </div>
    </section>;
}